// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ReadOnlyLayout_wrapper__zSI1Y","navbar":"ReadOnlyLayout_navbar__8Q10V","main":"ReadOnlyLayout_main__KymhR"};